import { useContext } from 'react';
import { InAppContext } from '../context/InApp';

export function useInApp() {
  const { inApp, setInApp } = useContext(InAppContext);
  return { inApp, setInApp };
}
